import React, { useMemo, useState } from 'react';
import { Select, Typography, Tag } from 'antd';
import { SearchOutlined, UserAddOutlined, UserOutlined, ClockCircleOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { searchEntities } from '../pages/services/callService';
import { getRecent } from '../utils/recentlyViewed';

const { Text } = Typography;

// Header global search across leads + clients, with recently-viewed when empty.
const GlobalSearch = ({ style }) => {
  const navigate = useNavigate();
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(false);

  const recentOptions = () => {
    const r = getRecent();
    if (!r.length) return [];
    return [{
      label: 'Recently viewed',
      options: r.map((x) => ({
        value: `lead:${x.id}`,
        label: <span><ClockCircleOutlined style={{ color: '#bfbfbf' }} /> {x.name} <Text type="secondary" style={{ fontSize: 11 }}>{x.sub}</Text></span>,
      })),
    }];
  };

  const doSearch = useMemo(() => {
    let t;
    return (q) => {
      clearTimeout(t);
      if (!q || q.length < 2) { setOptions(recentOptions()); return; }
      setLoading(true);
      t = setTimeout(async () => {
        try {
          const [leads, clients] = await Promise.all([
            searchEntities('lead', q), searchEntities('client', q),
          ]);
          const groups = [];
          if (leads.length) groups.push({
            label: 'Leads',
            options: leads.map((l) => ({
              value: `lead:${l.id}`,
              label: <span><UserAddOutlined style={{ color: '#e27e56' }} /> {l.Name} <Text type="secondary" style={{ fontSize: 11 }}>{l.Mobile || ''}{l.City ? ` · ${l.City}` : ''}</Text>{l.Priority ? <Tag style={{ marginLeft: 6 }}>{l.Priority}</Tag> : null}</span>,
            })),
          });
          if (clients.length) groups.push({
            label: 'Clients',
            options: clients.map((c) => ({
              value: `client:${c.id}`,
              label: <span><UserOutlined style={{ color: '#1890ff' }} /> {c.Name} <Text type="secondary" style={{ fontSize: 11 }}>{c.Mobile || ''}</Text></span>,
            })),
          });
          setOptions(groups);
        } catch { /* ignore */ }
        finally { setLoading(false); }
      }, 300);
    };
  }, []);

  const onSelect = (v) => {
    const [type, id] = v.split(':');
    setOptions([]);
    if (type === 'lead') navigate(`/leads/${id}`);
    else navigate('/clients');
  };

  return (
    <Select
      showSearch filterOption={false} value={null}
      placeholder="Search leads, clients…"
      suffixIcon={<SearchOutlined />}
      style={style}
      loading={loading}
      onSearch={doSearch}
      onSelect={onSelect}
      onFocus={() => setOptions(recentOptions())}
      options={options}
      notFoundContent={null}
      popupMatchSelectWidth={320}
    />
  );
};

export default GlobalSearch;
